
// Allow for runtime overrides of process.env

const buildtime = process.env || {}; // from CRA build
const runtime = window.env || {}; // generated from env.sh

const env = {
  ...buildtime,
  ...runtime,
};

export default env;



// WEBPACK FOOTER //
// ./src/env.js